/* @flow */
import React from 'react';
import {FormattedMessage} from 'react-intl';
import Icon from '../Icon/Icon';

import './HitFreeCancellation.less';

const HitFreeCancellation = () => (
    <span className="HitFreeCancellation">
        <span className="HitFreeCancellation__icon">
            <Icon name="check-circle" color="success" />
        </span>
        <span className="HitFreeCancellation__message">
            <FormattedMessage
                id="freeCancellation"
                description="Free cancellation"
                defaultMessage="Free cancellation"
            />
        </span>
    </span>
);

export default HitFreeCancellation;
